export default `query categoryList {
    categories {
      items {
        children {
          include_in_menu
          is_anchor
          level
          name
          position
          product_count
          uid
          url_path
          url_suffix
          children {
          editorial_box_1
editorial_box_2
related_filter_code
editorial_box_1_position
editorial_box_2_position
description_footer
            include_in_menu
            is_anchor
            level
            name
            position
            product_count
            uid
            url_path
            url_suffix
            children {
            editorial_box_1
editorial_box_2
related_filter_code
editorial_box_1_position
editorial_box_2_position
description_footer
              include_in_menu
              is_anchor
              level
              name
              position
              product_count
              uid
              url_path
              url_suffix
            }
          }
        }
        product_count
        name
        uid
      }
    }
  }
`